import React from "react";
import ContentInputsTypesEnum from "../../../../enums/ContentInputsTypesEnum";
import DebouncedInput from "../../../DebouncedInput";
import { useCurrentInputData } from "../useCurrentInputData";

interface Props {
  item: any;
  keyProp: number;
  saveContentInStore: any;
  generator: any;
  contentType: ContentInputsTypesEnum;
  currentInputData: any;
  toggleNewEditionsDetected: (value: boolean) => void;
}

const StepSubtitleField = (props: Props): JSX.Element => {
  const {
    item,
    saveContentInStore,
    generator,
    contentType,
    currentInputData,
    keyProp,
    toggleNewEditionsDetected,
  } = props;
  const currentInputDataRef = useCurrentInputData(currentInputData);

  const onChangeStepSubTitleHandler = (value: any) => {
    saveContentInStore(
      generator.changeStepSubtitle(
        { [contentType]: currentInputDataRef.current },
        keyProp,
        value
      )
    );
    toggleNewEditionsDetected(true);
  };

  if (!currentInputDataRef.current.hasSubtitle) return null;

  return (
    <DebouncedInput
      className="content-input__input"
      onChange={onChangeStepSubTitleHandler}
      defaultValue={item.subtitle}
      placeholder="Add step subtitle"
    />
  );
};

export default StepSubtitleField;
